<template>
  <div>
    <br />
    <b-row class="text-left">
      <b-col>
        <h3 class="text-primary font-weight-bold">
          Transaction - {{ items.acquirement_id }}
        </h3>
        <br />
        <h5>
          <router-link
            :to="{ name: 'TransactionLog' }"
            class="text-primary text-decoration-none"
          >
            <i class="fas fa-long-arrow-alt-left mr-2"></i>Kembali
          </router-link>
        </h5>
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col>
        <b-card body-class="py-0 px-3">
          <b-row>
            <b-col class="border-bottom py-4 text-left px-4">
              <b-row>
                <b-col class="align-self-center">
                  <h3>Payment Information</h3>
                </b-col>
                <b-col md="2" class="text-right">
                  <b-button
                    v-if="session.role == 'refund' && items.payment_method == 'SHOPEEPAY'"
                    class="px-5"
                    style="padding-top: 8px; padding-bottom: 8px"
                    variant="primary"
                    :disabled="
                      time >= 0 &&
                      time < 6 &&
                      items.payment_method == 'SHOPEEPAY' &&
                      shopeDate < 365
                    "
                    @click="refundShow = !refundShow"
                    >Refund</b-button
                  >
                  <b-button
                    v-else-if="session.role == 'refund' && items.payment_method == 'DANA'"
                    class="px-5"
                    style="padding-top: 8px; padding-bottom: 8px"
                    variant="primary"
                    :disabled="
                      time >= 0 &&
                      time < 1 &&
                      items.payment_method == 'DANA' 
                    "
                    @click="refundShow = !refundShow"
                    >Refund</b-button
                  >
                  <b-button
                    v-else-if="session.role == 'refund'"
                    class="px-5"
                    style="padding-top: 8px; padding-bottom: 8px"
                    variant="primary"
                    @click="refundShow = !refundShow"
                    >Refund</b-button
                  >
                </b-col>
              </b-row>
              <b-row>
                <b-col md="8"></b-col>
                <b-col md="4">
                  <label>
                    <label
                      v-if="session.role == 'refund' &&
                        items.payment_method == 'SHOPEEPAY'"
                      v-show="
                        time >= 0 &&
                        time < 6  &&
                        shopeDate < 1
                      "
                      class="text-right text-danger"
                      >Kiriman Kamu dengan pembayaran ShopeePay tidak bisa
                      direfund pada jam 00:00-06:00 WIB</label
                    >
                    <label
                      v-if="session.role == 'refund' && items.payment_method == 'DANA'"
                      v-show="
                        time >= 0 &&
                        time < 1 
                      "
                      class="text-right text-danger"
                      >Kiriman Kamu dengan pembayaran DANA tidak bisa
                      direfund pada jam 00:00-01:00 WIB</label
                    >
                  </label>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="text-left">
            <b-col md="4" class="border-right py-5 pl-4">
              <h5>Ref. Number / Invoice</h5>
              <h5 class="font-weight-bold text-primary">
                {{ items.transaction_code }}
              </h5>
            </b-col>
            <b-col md="8">
              <b-row>
                <b-col md="4" class="border-right py-5 px-4">
                  <h5>Amount</h5>
                  <h5 class="font-weight-bold text-primary">
                    {{ items.amount | rupiah }}
                    <label
                      class="text-success italic"
                      v-if="items.refunds && items.refunded != 0"
                    >
                      <i>Refunded: {{ items.refunded | rupiah }}</i>
                    </label>
                  </h5>
                </b-col>
                <b-col md="4" class="border-right py-5 px-4">
                  <h5>Payment Method</h5>
                  <h5
                    class="font-weight-bold text-primary text-uppercase"
                    v-if="items.issuer"
                  >
                    {{ items.payment_method }} - {{ items.issuer }}
                  </h5>
                  <h5 class="font-weight-bold text-primary" v-else>
                    {{ items.payment_method }}
                  </h5>
                </b-col>
                <b-col md="4" class="py-5 px-4">
                  <h5>Transaction Status</h5>
                  <h5 class="font-weight-bold text-primary">
                    {{ items.status }}
                  </h5>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col class="text-left">
        <b-card class="pl-2">
          <h3>Order Details</h3>
          <hr />
          <b-row>
            <b-col md="4">Ref. Number / Invoice</b-col>
            <b-col class="font-weight-bold mb-2">{{
              items.transaction_code
            }}</b-col>
          </b-row>
          <b-row>
            <b-col md="4">Payment Type</b-col>
            <b-col class="font-weight-bold mb-2">
              <p v-if="items.issuer" class="text-uppercase">
                {{ items.payment_method }} - {{ items.issuer }}
              </p>
              <p v-else>
                {{ items.payment_method }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">Amount</b-col>
            <b-col class="font-weight-bold mb-2">
              {{ items.amount }}
              <label
                class="text-success italic"
                v-if="items.refunds && items.refunded != 0"
              >
                <i>Refunded: {{ items.refunded | rupiah }}</i>
              </label>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">Paid Time</b-col>
            <b-col class="font-weight-bold mb-2">{{
              items.paid_at | DateTimes
            }}</b-col>
          </b-row>
          <b-row>
            <b-col md="4">Latest Status</b-col>
            <b-col class="font-weight-bold mb-2">{{ items.status }}</b-col>
          </b-row>
          <b-row v-if="items.refunds">
            <b-col md="4">Refund Reason</b-col>
            <b-col class="font-weight-bold mb-2">
              <label v-for="data in items.refunded_reasons" :key="data">{{
                data
              }}</label>
            </b-col>
          </b-row>
        </b-card>
        <br />
      </b-col>
      <b-col class="text-left">
        <b-card class="pl-2">
          <h3>Customer Details</h3>
          <hr />
          <b-row>
            <b-col md="4">Username</b-col>
            <b-col class="font-weight-bold mb-2">{{ member.username }}</b-col>
          </b-row>
          <b-row>
            <b-col md="4">Name</b-col>
            <b-col class="font-weight-bold mb-2">{{
              member.first_name + member.last_name
            }}</b-col>
          </b-row>
          <b-row>
            <b-col md="4">Phone Number</b-col>
            <b-col class="font-weight-bold mb-2">{{ member.phone }}</b-col>
          </b-row>
          <b-row>
            <b-col md="4">Email</b-col>
            <b-col class="font-weight-bold mb-2">{{ member.email }}</b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col>
        <b-card body-class="py-0 px-2 mx-1">
          <b-row>
            <b-col class="py-3 text-left px-4">
              <h3>Item Details</h3>
            </b-col>
          </b-row>
          <b-row class="text-left bg-gray-200 py-3">
            <b-col md="6">Product Name</b-col>
            <b-col md="2">Quantity</b-col>
            <b-col md="2">Unit Price</b-col>
            <b-col md="2">Sub Total</b-col>
          </b-row>
          <b-row
            class="text-left py-3 border-bottom"
            v-for="data in items.item_details"
            :key="data"
          >
            <b-col md="6">{{ data.product_name }}</b-col>
            <b-col md="2">{{ data.quantity }}</b-col>
            <b-col md="2">{{ data.unit_price | rupiah }}</b-col>
            <b-col md="2">{{ data.sub_total | rupiah }}</b-col>
          </b-row>
          <b-row class="text-left py-3 font-weight-bold">
            <b-col class="pl-4" md="3">{{ items.paid_at | DateTime }}</b-col>
            <b-col offset-md="7" md="2">{{ total() | rupiah }}</b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <br />
    <br />
    <b-row>
      <b-col>
        <b-card body-class="py-0 px-2 mx-1">
          <b-row>
            <b-col class="py-3 text-left px-4">
              <h3>Refund History</h3>
            </b-col>
          </b-row>
          <b-row class="text-left bg-gray-200 py-3">
            <b-col class="pl-4" md="2">Create Time</b-col>
            <b-col md="2">Reason</b-col>
            <b-col md="2">Amount</b-col>
            <b-col md="2">Result</b-col>
            <b-col md="2">Result Message</b-col>
            <b-col md="2">By</b-col>
          </b-row>
          <b-row
            class="text-left py-3 border-bottom"
            v-for="data in items.refunds"
            :key="data"
          >
            <b-col class="pl-4" md="2">{{ data.created_at | DateTimes }}</b-col>
            <b-col md="2">{{ data.reason }}</b-col>
            <b-col md="2">{{ data.amount | rupiah }}</b-col>
            <b-col md="2">{{ data.result }}</b-col>
            <b-col md="2">{{ data.result_message }}</b-col>
            <b-col md="2">{{ data.refund_by }}</b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      v-model="refundShow"
      id="modal-prevent-closing"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
    >
      <h4 class="font-weight-bold">Refund</h4>
      <br />
      <b-form-group
        id="fieldset-1"
        label="Amount"
        label-class="control-label"
        class="required font-weight-bold"
        label-for="input-1"
      >
        <input
          v-validate="'required|numeric|min_value:1'"
          v-model="amount"
          name="amount"
          data-vv-as="Amount"
          id="input-1"
          type="number"
          class="form-control"
          placeholder="Enter Amount"
        />
        <b-form-invalid-feedback id="input-amount-feedback">{{
          veeErrors.first("amount")
        }}</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        id="fieldset-1"
        label="Reason"
        label-class="control-label"
        class="required font-weight-bold"
        label-for="input-1"
      >
        <input
          v-validate="'required'"
          v-model="reason"
          name="reason"
          data-vv-as="Reason"
          id="input-1"
          class="form-control"
          placeholder="Enter Reason"
        />
        <b-form-invalid-feedback id="input-reason-feedback">{{
          veeErrors.first("reason")
        }}</b-form-invalid-feedback>
      </b-form-group>
      <br />
      <b-row>
        <b-col>
          <b-button
            variant="light"
            @click="refundShow = !refundShow"
            class="text-primary border-secondary"
            block
            size="lg"
            >Cancel</b-button
          >
        </b-col>
        <b-col>
          <b-button
            variant="primary"
            :disabled="loadingRefund"
            @click="addRefund()"
            block
            size="lg"
          >
            <b-spinner label="Spinning" v-show="loadingRefund"></b-spinner
            >Refund
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      session: this.$session.get("jwt"),
      widthImage: null,
      heightImage: null,
      loading: false,
      loadingRefund: false,
      items: [],
      member: [],
      amount: "",
      reason: "",
      urlImage: "",
      modalImage: false,
      refundShow: false,
      image: "",
      date: new Date(),
      timestamp: "",
      hour: new Date().getHours(),
      minute: new Date().getMinutes(),
      second: new Date().getSeconds(),
      utc: new Date().getUTCDate(),
      time: new Date().getHours(),
      compare: new Date("October 13, 2020 11:13:00"),
    };
  },
  async beforeCreate() {
    this.$store
      .dispatch(
        "TransactionLogModule/getTransactionLogID",
        this.$route.params.id
      )
      .then((response) => {
        this.items = response;
        const formData = new FormData();
        if(this.items.member_code != "") {

            formData.append("member_code", this.items.member_code);
            this.$store
              .dispatch("TransactionLogModule/getMemberID", formData)
              .then((response) => {
                this.member = response;
              })
              .catch((error) => {
                this.loading = false;
              });

          } else {
            if(this.items.locker_order_type != "") {
              this.$store
                .dispatch(
                  "TransactionLogModule/getLockerCustomerInfo",
                  this.items.transaction_code
                )
                .then((response) => {
                  this.member = {
                    first_name: response.name,
                    last_name: "",
                    phone: response.phone_number,
                    email: response.email,
                  }
                })
                .catch((error) => {
                  this.loading = false;
                });
            }
          }
      })
      .catch((error) => {
        this.loading = false;
      });
    this.$store
      .dispatch("TransactionLogModule/getTimeWIB")
      .then((response) => {
        this.time = new Date(response.data.data).getHours();
      })
      .catch((error) => {
        this.loading = false;
      });
  },
  created() {
    // this.hitt();
  },
  computed: {
    shopeDate() {
      return Math.floor(
        (this.date - new Date(this.items.paid_at)) / 1000 / 86400
      );
    },
  },
  methods: {
    hitt() {
      setInterval(this.getNow, 10000);
    },
    getNow: function () {
      // if (
      //   this.items.payment_method == "SHOPEEPAY" &&
      //   this.shopeDate < 1 &&
      //   this.$route.name == "detailTransactionLog"
      // ) {
      //   this.$store
      //     .dispatch("TransactionLogModule/getTimeWIB")
      //     .then((response) => {
      //       this.time = new Date(response.data.data).getHours();
      //     })
      //     .catch((error) => {
      //       this.loading = false;
      //     });
      // } else {
      // }
      // const today = new Date();
      // const date =
      //   today.getFullYear() +
      //   "-" +
      //   (today.getMonth() + 1) +
      //   "-" +
      //   today.getDate();
      // const time =
      //   today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      // const dateTime = date + " " + time;
      // this.hour = today.getHours();
      // this.minute = today.getMinutes();
      // this.second = today.getSeconds();
      // this.timestamp = dateTime;
    },
    refresh() {
      this.$store
        .dispatch(
          "TransactionLogModule/getTransactionLogID",
          this.$route.params.id
        )
        .then((response) => {
          this.items = response;
          const formData = new FormData();
          if(this.items.member_code != "") {

            formData.append("member_code", this.items.member_code);
            this.$store
              .dispatch("TransactionLogModule/getMemberID", formData)
              .then((response) => {
                this.member = response;
              })
              .catch((error) => {
                this.loading = false;
              });

          } else {
            if(this.items.locker_order_type != "") {
              this.$store
                .dispatch(
                  "TransactionLogModule/getLockerCustomerInfo",
                  this.items.transaction_code
                )
                .then((response) => {
                  this.member = {
                    first_name: response.name,
                    last_name: "",
                    phone: response.phone_number,
                    email: response.email,
                  }
                })
                .catch((error) => {
                  this.loading = false;
                });
            }
          }
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    total() {
      let total = 0;
      for (let i = 0; i < this.items.item_details.length; i++) {
        total += parseInt(this.items.item_details[i].sub_total);
      }
      return total;
    },
    refunds() {
      let total = 0;
      for (let i = 0; i < this.items.refunds.length; i++) {
        total += parseInt(this.items.refunds[i].amount);
      }
      return total;
    },
    addRefund() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$swal({
            title: "Are you sure?",
            text: "You will refund this Transaction!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, refund it!",
          }).then((result) => {
            if (result.value) {
              this.loadingRefund = true;
              const formData = new FormData();
              formData.append("transaction_log_id", this.$route.params.id);
              formData.append("amount", this.amount);
              formData.append("reason", this.reason);
              this.$store
                .dispatch("TransactionLogModule/addRefund", formData)
                .then((response) => {
                  this.refundShow = false;
                  this.loadingRefund = false;
                  this.refresh();
                  this.$swal({
                    type: "success",
                    title: "Your refund is success",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  console.log(response);
                })
                .catch((error) => {
                  this.loadingRefund = false;
                  this.loading = false;
                  this.$swal({
                    type: "error",
                    title: error.response.data.message,
                    text: error.response.data.data,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.serverError = error.response.data;
                  console.log(error);
                });
            }
          });
        } else {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: this.$validator.errors.all(),
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },
  },
};
</script>

<style>
</style>